<ng-container *ngIf="form">
  <form [formGroup]="form">
    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Name</mat-label>
      <input matInput placeholder="" [formControlName]="'name'" />
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Description</mat-label>
      <input matInput placeholder="" [formControlName]="'description'" />
    </mat-form-field>
    
    <div class="items">
      <h3>Items</h3>
      
      <!-- Filter Form Component -->
      <app-filter-form
        *ngIf="groupInterface === GroupInterfaces.ExistingUser || groupInterface === GroupInterfaces.Brand"
        [filters]="filters"
        [groupInterface]="groupInterface"
        (addFilter)="addFilter()"
        (removeFilter)="removeFilter($event)">
      </app-filter-form>
      
      <!-- Search and Pagination Component -->
      <app-search-pagination
        [searchForm]="searchForm"
        [itemCount]="itemCount"
        [selectedItemsCount]="selectedItemsCount"
        [label]="label"
        (pageChanged)="pageEvent($event)">
      </app-search-pagination>
      
      <!-- Item Selection Component -->
      <app-item-selection
        [items]="items"
        [form]="form"
        [selectedIds]="selectedIds"
        [selectAllState]="selectAllState"
        [label]="label"
        (toggleSelectAll)="onToggleSelectAll()">
      </app-item-selection>
    </div>
  </form>
</ng-container>
<app-inlinemessage *ngIf="errorMessage" level="error" [message]="errorMessage"></app-inlinemessage>
<span class="required">* Required Field</span>
<div class="buttons" mat-dialog-actions>
  <button
    *ngIf="!data"
    mat-raised-button
    [disabled]="!canSave"
    class="donebutton"
    color="primary"
    (click)="save()"
  >
    OK
  </button>
  <button mat-button (click)="close()">{{ data ? 'Close' : 'Cancel' }}</button>
</div>